
import { Component } from "nuxt-property-decorator"
import TrustpilotBaseComponent from "~/mixins/trustpilotBase"

@Component
export default class TrustpilotFooterComponent extends TrustpilotBaseComponent {}
